

export default {
  login: state => state.session.login,
};
